import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react';
import { useCreateActions } from 'components/global/HeaderCreateMenu';
import { M } from './theme';

/** Same `useCreateActions` list as the desktop header menu, so both stay in sync. */
export function CreateSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const actions = useCreateActions();

  if (!open) return null;

  return (
    <>
      <div
        className="absolute inset-0 z-[46] animate-in fade-in-0"
        style={{ background: 'rgba(17,24,39,.5)' }}
        onClick={onClose}
      />
      <div
        className="absolute inset-x-0 bottom-0 z-[47] animate-in slide-in-from-bottom-4 rounded-t-lg px-4 pt-2"
        style={{
          background: M.card,
          boxShadow: '0 -14px 44px rgba(17,24,39,.24)',
          paddingBottom: 'max(1.375rem, env(safe-area-inset-bottom))',
        }}
      >
        <div className="flex justify-center py-2 pb-3.5">
          <span className="h-[5px] w-[42px] rounded-full" style={{ background: M.chevron }} />
        </div>
        <span className="mb-3 block text-[17px] font-extrabold tracking-[-0.02em]" style={{ color: M.ink }}>
          {t('create', 'Create')}
        </span>
        <div className="space-y-1">
          {actions.map((a) => (
            <button
              key={a.to}
              type="button"
              onClick={() => {
                onClose();
                navigate(a.to);
              }}
              className="flex w-full items-center gap-3 rounded-md px-2 py-3 text-left active:bg-[color:var(--m-muted)]"
              style={{ ['--m-muted' as string]: M.muted }}
            >
              <span
                className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg"
                style={{ background: M.accentTint, color: M.accent }}
              >
                <a.icon size={19} />
              </span>
              <span className="flex-1 text-[14px] font-semibold" style={{ color: M.ink }}>
                {a.label}
              </span>
              <ChevronRight size={18} style={{ color: M.chevron }} />
            </button>
          ))}
        </div>
      </div>
    </>
  );
}

export default CreateSheet;
